import { Injectable } from '@angular/core';
import {
  HttpContextToken,
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { ToastService } from "../../services/toast.service";

export const SKIP_STATUS_CODES:HttpContextToken<number[]> = new HttpContextToken(() => []);
@Injectable()
export class ErrorResponseHandlerInterceptor implements HttpInterceptor {

  constructor(
    private toastService: ToastService,
  ) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const statusCodesToSkip = request.context.get(SKIP_STATUS_CODES);
    return next.handle(request)
      .pipe(
        catchError((error: HttpErrorResponse) => {
          if(!statusCodesToSkip.includes(error.status)) {
            /**
             * t(error.general)
             */
            this.toastService.showErrorToast('error.general');
          }
          return throwError(() => error);
        }),
      );

  }
}
